import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  constructor(private auth: AuthService, private router: Router) {}

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Output() instructionsEvent = new EventEmitter<any>();

  @Output() clear = new EventEmitter<any>();

  @Input() isDisable: boolean;

  @Input() show: boolean;

  @Input() title: string;

  ngOnInit() {}

  // EXECUTE WHEN LOGOUT BUTTON CLICKED ON HEADER
  logout() {
    this.auth.doLogout();

    //
    // Wipe out any and all items in the local storage.
    //
    localStorage.clear();

    // Now that we have removed all of the data that tells the system we're logged in, redirect back to the RAL website.
    window.location.href = environment.logoutRedirectUrl;
  }

  instructions() {
    this.instructionsEvent.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts